/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'hdr-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const hdrLabel = `${prefix}.hdrLabel`;

export const ENGLISH = {
    [hdrLabel]: 'Header',
};
